import { FC, Fragment } from 'react';
import {
    PerformMultiSelect,
    PerformEnum,
    PerformDateFilterSelector,
    PerformDateRangeFilterSelector,
    PerformGreaterLessInput,
} from '../perform-indicator/perform-indicator';
import {
    CustomerType as CustomerTypeEnum,
    CustomerFilterDto,
    CustomFieldsFilterDto,
    CustomFieldsFilterItem,
} from '@servicetitan/application-data/marketing';
import * as Styles from './segment-parts.module.less';

interface CustomerProps {
    segmentId: number;
    customer?: CustomerFilterDto;
    customFields?: CustomFieldsFilterDto;
    CustomFieldsComponent?: FC<{
        segmentId: number;
        type: string;
        filters?: CustomFieldsFilterItem[];
    }>;
}

export const Customer: FC<CustomerProps> = ({
    segmentId,
    customer,
    customFields,
    CustomFieldsComponent,
}) => (
    <Fragment>
        <div className={Styles.segmentCardKpiName}>Customer</div>
        {customer && (
            <div>
                <PerformEnum
                    name="Customer Type"
                    value={customer.customerType}
                    enumType={CustomerTypeEnum}
                />
                <PerformMultiSelect name="Customer Zip Code" value={customer.customerZipCodes} />
                <PerformMultiSelect name="Customer Tag" value={customer.customerTags} />
                <PerformDateFilterSelector
                    name="Last Email Date"
                    valueStatic={customer.noEmailsSince}
                    valueDynamic={customer.noEmailsSinceRelative}
                />
                <PerformDateRangeFilterSelector
                    name="Created On"
                    valueStatic={customer.createdOn}
                    valueDynamic={customer.createdOnRelative}
                />
                <PerformGreaterLessInput name="Balance" value={customer.balance} />
                <PerformDateRangeFilterSelector
                    name="Latest Credit Card Expiration Date"
                    valueStatic={customer.lastCreditCardExpirationDate}
                    valueDynamic={customer.lastCreditCardExpirationDateRelative}
                />
            </div>
        )}
        {CustomFieldsComponent && (
            <CustomFieldsComponent
                segmentId={segmentId}
                type="customerCustomFields"
                filters={customFields?.filters}
            />
        )}
    </Fragment>
);
